export default __webpack_public_path__ + "static/media/verification3.8005ff23.png";